import { capitalizeString } from 'lib/helpers'
// import { SaatchiMetaData as MetaDataConnect } from 'lib/browse/containers/MetaData'
export const metadataHelper: Array<string> = [
  'black',
  'brown',
  'white',
  'silver',
  'gold',
  'patina',
  'other',
]
export const prettyCategory = (category: string | null | undefined): string => {
  if (!category) {
    return 'Art'
  }

  return category
    .replace(/^Mixed Media$/, 'Mixed Media Art')
    .replace(/^Printmaking$/, 'Art Prints')
    .replace(/^Digital$/, 'Digital Art')
    .replace(/^Installation$/, 'Art Installations')
    .replace(/^all$/, 'Art')
}
export function joinTitles(
  params: Record<string, any>,
  seperator: string | null | undefined
): string {
  const order = ['query', 'style', 'subject', 'mediums', 'category', 'materials']
  let title = ''

  if (!params) {
    return title
  }

   
  order.map((key) => {
    // Check that the category isn't all, if so, set the string to 'Art' for titles
    if (key === 'category') {
      if (params[key] === null) {
        params[key] = 'Art'
      } else {
        params[key] = (params[key] || '')
          .replace(/^Mixed Media$/, 'Mixed Media Art')
          .replace(/^Printmaking$/, 'Art Prints')
          .replace(/^Digital$/, 'Digital Art')
          .replace(/^Installation$/, 'Art Installations')
      }
    }

    // Check there is a String and Doesn't already Exist => Abstract Abstract
    if (params[key] && title.search(params[key]) === -1) {
      if (key === 'query') {
        title = `${capitalizeString(`${params[key].replace(/-/g, ' ')}`)}${seperator || ''} `
      } else {
        title += capitalizeString(`${params[key]}${seperator || ''} `)
      }
    }
  })
  return title
}
// const titles = joinTitles(titleParams)
// const printHeadline = `${!titles ? 'Prints' : `${titles} Prints`} `
// const originalHeadline = `${!titles ? 'Original Artworks' : `Original ${titles}`} ${
//   material ? `on ${material}` : ''
// } `
// const headline = (isPrintPath ? printHeadline : originalHeadline).replace(/\s+/g, ' ')
//
// const getKeywords =
//   seoMetadata.keywords && !isPrintPath
//     ? `${seoMetadata.keywords}, `
//     : joinTitles(titleParams, ',') +
//       (material ? `${material}, ` : '') +
//       (country ? `${country}, ` : '') +
//       (artistRecognition ? `${artistRecognition}, ` : '')
// const title =
//   seoMetadata.title && !isPrintPath
//     ? seoMetadata.title
//     : `${headline}${country ? ` From ${capitalizeString(country)} ` : ` For Sale `}${
//         artistRecognition ? `By Artists Featured In ${artistRecognition} ` : ''
//       }| Saatchi Art`.replace(/\s+/g, ' ')
// const description =
//   seoMetadata.description && !isPrintPath
//     ? seoMetadata.description
//     : `Shop ${headline}created by thousands of emerging artists from ${
//         country ? `${capitalizeString(country)}` : `around the world`
//       }${
//         artistRecognition ? ` featured in ${artistRecognition}` : ''
//       }. Buy original art worry free with our 14 day satisfaction guarantee.`.replace(/\s+/g, ' ')
// const keywords = `${getKeywords}original art, art, artworks, saatchi art, saatchi, emerging art, prints, art print`
//
// const noFollow = totalHits < 10 || noBots
//
// const siteUrl = process.env.SITE_URL || 'https://www.saatchiart.com/'
export const checkIfUrlShouldBeIndexed = (urlPath: string): boolean => {
  if (!(urlPath || '').includes('?')) {
    // If the URL doesn't contain a query string, we can index it
    return true
  }

  // Filter urlPath to just assess query strings appended to ? character
  const query = urlPath.replace(/^.*\?(.*)$/, '$1')

  if (
    query.search(
      /artist_recognition|color|country|materials|mediums|orientation|price|recommended|size|styles|subject|prints_availability|query/
    ) === -1
  ) {
    return true
  }

  return false
}
